import Text from '../../../../../../components/shared/Typography/Text';
import { CheckpointsBlock } from '../../../../../LandingV2/Page/RightSide/blocks/TripEventBlock/CheckpointsBlock';

function Checkpoints() {
  return (
    <Text size="medium">
      <CheckpointsBlock gap="6px" />
    </Text>
  );
}

export default Checkpoints;
